import { ModuleUser } from 'app/library/module-user/models/module-user.model';

export class UpdateTemplateResponsibleManager {
    static readonly type = '[Module] UpdateTemplateResponsibleManager';

    constructor(public payload: ModuleUser[]) {}
}
